module.exports = __webpack_public_path__ + "static/media/META-Front-End-Engineer-Certification.e8b9eb77.png";